import { View } from 'foundations-components/components/View';
import { FullPriceContainerBlockLarge } from './PriceStyledComponents';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriceDisplayHubspotCredits = ({
  price,
  showPricePerMonthPerSeat = false,
  seleniumId,
  currencyCode,
  currencyCodeUnit
}) => {
  return /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(FullPriceContainerBlockLarge, {
      children: /*#__PURE__*/_jsx(PricePerMonth, {
        price: price,
        currencyCode: currencyCode,
        seleniumId: seleniumId,
        showPricePerMonthPerSeat: showPricePerMonthPerSeat,
        currencyCodeUnit: currencyCodeUnit
      })
    })
  });
};